<kendo-fileselect
  #fileSelectCmp
  [accept]="restrictions | acceptFiles"
  zoneId="myZone"
  [ngModel]="files"
  [disabled]="disabled"
  [showFileList]="false"
  [restrictions]="restrictions"
  (select)="onSelectFiles($event)"
  [multiple]="multiple"
></kendo-fileselect>

<kendo-splitter
  *ngIf="withPreview; else fileList"
  class="file-list-wrapper"
  orientation="horizontal"
  [kendoUploadDropZone]="'myZone'"
>
  <kendo-splitter-pane size="30%">
    <ng-container *ngTemplateOutlet="fileList"></ng-container>
  </kendo-splitter-pane>
  <kendo-splitter-pane class="attachment-viewer">
    <ng-container *ngIf="selectedFile">
      <app-file-viewer [attach]="selectedAttach"></app-file-viewer>
    </ng-container>
  </kendo-splitter-pane>
</kendo-splitter>

<ng-template #fileName let-file>
  <span *ngIf="!isEditable(file)" class="file-name" [title]="file.name">{{ file.name }}</span>
</ng-template>

<ng-template #fileNameInput let-file>
  <input
    #input
    kendoTextBox
    class="file-name__input"
    [ngModel]="file.name"
    required
    (blur)="clearEditableState(input.value)"
    (keydown.enter)="clearEditableState(input.value)"
    (mousedown)="$event.stopPropagation()"
  />
</ng-template>

<ng-template #fileList>
  <ul cdkDropList class="file-list" (cdkDropListDropped)="drop($event)">
    <li
      class="file-box"
      [class.file-box_selected]="isSelectedFile(file)"
      cdkDrag
      [cdkDragDisabled]="disabled || !canEdit"
      *ngFor="let file of files"
      (click)="selectFile(file)"
      (cdkDragStarted)="onDragStarted()"
    >
      <span class="file-group-wrapper">
        <span class="file-group k-icon" [ngClass]="file | fileGroupClass"></span>
      </span>
      <span class="file-name-size-wrapper">
        <ng-container
          *ngTemplateOutlet="isEditable(file) ? fileNameInput : fileName; context: { $implicit: file }"
        ></ng-container>
        <span [ngClass]="file | fileStatusClass">{{ file | fileStatusText : fileSelectCmp['localization'] }} </span>
      </span>
      <kendo-dropdownbutton
        #dropDownBtn
        fillMode="flat"
        *ngIf="isSettingsBtnVisible(file)"
        [data]="settings"
        icon="more-vertical"
        [popupSettings]="settingsBtnPopupOptions"
        (mousedown)="$event.stopPropagation()"
        (click)="onDropDownClick($event, dropDownBtn)"
      >
        <ng-template kendoDropDownButtonItemTemplate let-dataItem>
          <div
            class="command"
            (mousedown)="$event.stopPropagation()"
            (click)="dataItem.handler && dataItem.handler(file, dropDownBtn)"
          >
            <span *ngIf="dataItem.icon" class="k-icon k-i-{{ dataItem.icon }}"></span>
            <span class="command__name">{{ dataItem.text }}</span>
          </div>
        </ng-template>
      </kendo-dropdownbutton>
    </li>
  </ul>
</ng-template>
